export const graphDisabledOption = {
  background: {
    color: '#F4F4F5'
  },
  autoResize: true,
  translating: {
    restrict: false
  },
  panning: {
    enabled: true
  },
  interacting: false,
  selection: false,
  async: false,
  allowLoop: false,
  mousewheel: true,
  highlighting: false,
  keyboard: {
    enabled: false
  },
  disabled: true
}

/**
 * "PASS": "通过","REJECT": "拒绝","ROLLBACK": "回滚","TRANSFER": "转交","ADD_SIGN": "加签","CLOSE": "结束流程", "CANCEL"：“撤回流程”，"CREATE": "重新发起"
 */
export enum AuthBtn {
  PASS = 'PASS',
  REJECT = 'REJECT',
  ROLLBACK = 'ROLLBACK',
  TRANSFER = 'TRANSFER',
  ADD_SIGN = 'ADD_SIGN',
  CANCEL = 'CANCEL',
  CLOSE = 'CLOSE',
  CREATE = 'RESUBMIT'
}
